module.exports = __webpack_public_path__ + "img/mood-icon-4.b2c23497.svg";